import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../store';
import { select, Store } from '@ngrx/store';
import * as fromModels from '../models';
import { ActivatedRoute, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-contract-summary',
  templateUrl: './contract-summary.component.html'
})
export class ContractSummaryComponent {
  searchResultsState$: Observable<fromStore.SummaryState>;
  downloadRequestFormState$: Observable<fromStore.RequestFormState>;

  private _subscription: Subscription;
  private _searchCriteria: fromModels.LoadSummaryRequest;
  private _pagingSorting: fromModels.PagingSorting;

  isCopied = false;

  constructor(
    private _store: Store<fromStore.ContractDetailsState>,
    private route: ActivatedRoute,
    private router: Router,
    private clipboard: Clipboard,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this.searchResultsState$ = this._store.pipe(select(fromStore.getContractSummaryState));
    this.downloadRequestFormState$ = this._store.pipe(select(fromStore.getContractRequestFormState));

    this._subscription = this.searchResultsState$.subscribe(s => {
      this._searchCriteria = s.searchCriteria;
      this._pagingSorting = s.pagingSorting;
    });

    // Subscribe to query params
    this.route.queryParams.subscribe(params => {
      this._store.dispatch(new fromStore.ProcessQueryString(this.router.url));
    });
  }

  onDestroy() {
    this._subscription.unsubscribe();
  }

  nextPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.NextPage(this._searchCriteria, this._pagingSorting));
  }

  prevPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.PrevPage(this._searchCriteria, this._pagingSorting));
  }

  setPageSize(pageSize: number) {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.SetPageSize(pageSize, this._searchCriteria));
  }

  lastPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.LastPage(this._searchCriteria, this._pagingSorting));
  }

  firstPage() {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.FirstPage(this._searchCriteria, this._pagingSorting));
  }

  sortBy(column: string) {
    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.SortBy(column, this._searchCriteria, this._pagingSorting));
  }

  onDownloadAll() {
    const request: fromModels.DownloadSummarySearchRequest = this._searchCriteria;
    this._store.dispatch(new fromStore.DownloadSummarySearch(request));
  }

  downloadContract(id: string) {
    this._store.dispatch(new fromStore.DownloadRequestForm({ id: id }));
  }

  copyLink(contract: fromModels.SummaryResult) {
    if (!contract.shareLink || contract.isCopied) return;

    this.clipboard.copy(contract.shareLink);

    // Set copied state
    contract.isCopied = true;

    // Trigger detection immediately
    this.cdr.markForCheck(); // or detectChanges()

    this.zone.runTask(() => {
      setTimeout(() => {
        contract.isCopied = false;
        this.cdr.markForCheck();
      }, 2000);
    });
  }
}
